export function isNorwegianMobile(input: string | undefined | null): boolean {
  if (!input) return false;
  const cleaned = input.replace(/[\s\-+]/g, "").replace(/^(?:00)?47/, "");
  return /^[49]\d{7}$/.test(cleaned);
}
